import React from 'react';
import * as Render from '../platformui/Base/Render';
import DescriptionList from '../platformui/DescriptionList';
export default (props) => (
  <DescriptionList
    {...props}
    Heading={Render.Property(props.Heading, 'Heading')}
    Preamble={Render.Property(props.Preamble, 'Preamble')}
    ShowNumber={props.ShowNumber}
    List={props.List}
  />
);
